<template>
  <div class="report_item_wrapper">
    <div class="report_header">
      <div class="item_title">
        <i class="iconfont">&#xe60e;</i>
        <span>{{$t('title.bloodsugar')}}</span>
        <span
          class="srart_end_time"
          v-show="echartShows"
        >{{time}}</span>
      </div>
      <div class="item_warn"></div>
    </div>
    <div
      class="echarts_wrapper"
      v-show="echartShows"
    >
      <div class="draw_echarts">
        <keep-alive>
          <div
            class="chart"
            :id="id"
          ></div>
        </keep-alive>
      </div>
      <p class="chartTip">*{{$t('tag.shipin')}}</p>
      <div class="parameter">
        <ul>
          <li class="item">
            <span
              :class="['value',wholeDayAve.value!==''&&wholeDayAve.color!=='normal'?wholeDayAve.color:'normal']"
              @click="showDetail(wholeDayAve.color, wholeDayAve.txt)"
            >
              <template v-if="wholeDayAve.value!==''">
                <strong>{{wholeDayAve.value}}</strong>
                <i>mmol/L</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.bloodsugar.ave')}}</p>
          </li>
          <li class="item">
            <span
              :class="['value',low.value!==''&&low.color?low.color:'normal']"
              @click="showDetail(low.color, low.txt)"
            >
              <template v-if="low.value!==''">
                <strong>{{low.value}}</strong>
                <i>mmol/L</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.bloodsugar.lowest')}}</p>
          </li>
          <li class="item">
            <span
              :class="['value',top.value!==''&&top.color?top.color:'normal']"
              @click="showDetail(top.color, top.txt)"
              b
            >
              <template v-if="top.value!==''">
                <strong>{{top.value}}</strong>
                <i>mmol/L</i>
              </template>
              <template v-else>--</template>
            </span>
            <p class="title">{{$t('tag.bloodsugar.height')}}</p>
          </li>
        </ul>
      </div>
      <!-- 健康报告 -->
      <div class="read part-top">
        <div class="header">
          <i class="iconfont">&#xe61d;</i>
          <h2>{{$t('title.secondaryTitle.sugarReport')}}</h2>
        </div>
        <div class="content">
          <div :class="['article',contentShow ? 'show' : 'hidden']">
            <p>{{content}}</p>
          </div>
          <div
            :class="['mask',contentShow ? 'show' : 'hidden']"
            @click="contentToggle"
          >
            <i
              class="iconfont"
              v-show="!contentShow"
            >&#xe632;</i>
            <i
              class="iconfont"
              v-show="contentShow"
            >&#xe633;</i>
          </div>
        </div>
      </div>
    </div>
    <div
      class="nodata"
      v-show="!echartShows"
    >{{$t('tag.bloodsugar.noyear')}}</div>
  </div>
</template>
<script>
export default {
  name: "yearSugar",
  props: {
    sendTime: {
      type: String,
      default: ""
    }
  },
  data() {
    return {
      emit: {},
      echartShows: true,
      id: "yearSugar",
      contentShow: false,
      // 图表
      chart_x_time: [],
      bsugarValue: [],
      top: "",
      low: "",
      wholeDayAve: [],
      content: "",
      time: "",
      statec: "",
      appType: {
        appName: this.$route.params.appName
      }
    };
  },
  mounted() {
    var echartsDom = document.getElementById(this.id);
    var contentHeight = window.getComputedStyle(echartsDom).height;
    var contentWidth = window.getComputedStyle(echartsDom).width;
    echartsDom.style.height = contentHeight;
    echartsDom.style.width = contentWidth;
  },
  methods: {
    getEchartsDataInfo() {
      let postData = {
        week: this.sendTime,
        userid: this.$route.params.userID,
        friendid: this.$route.params.friendID,
        token: this.$route.params.token
      };
      this.$axios
        .getYearbloodsugar(this.appType, postData)
        .then(this.getEchartsDataInfoSucc);
    },
    getEchartsDataInfoSucc(res) {
      this.emit.code = res.code;
      this.$emit("sugarcode", this.emit);
      if (res.code === 0 && res.data) {
        this.echartShows = true;
        const getData = res.data;
        let startTime = getData.startTime;
        let endTime = getData.endTime;
        // 图表
        this.chart_x_time = [];
        this.bsugarValue = [];
        this.bsugarValue = getData.echarts;
        this.wholeDayAve = getData.ave;
        this.top = getData.top;
        this.low = getData.low;
        this.chart_x_time = getData.time;

        this.statec = getData.statec;
        this.content =
          this.$t("bloodsugar.year.a1") +
          getData.ave.value +
          this.$t("bloodsugar.year." + this.statec);
        // console.log('sugar=>' + this.chart_x_time + '<br>' + 'this.bsugarValue:=>' + this.bsugarValue)
        this.time = "(" + startTime + "-" + endTime + ")";
        this.init();
        this.setOption(this.options);
      } else {
        this.echartShows = false;
      }
    },
    init() {
      let _this = this;
      this.chart = this.$echarts.init(document.getElementById(this.id));
      window.addEventListener("resize", function () {
        _this.chart && _this.chart.resize();
      });
    },
    setOption(option) {
      if (!this.chart) {
        return;
      }
      this.chart.setOption(option);
    },
    contentToggle() {
      this.contentShow = !this.contentShow;
    },
    dispose() {
      if (!this.chart) {
        return;
      }
      this.chart.dispose();
      this.chart = null;
    },
    showDetail(color, txt) {
      if (color !== "normal") {
        this.$alertPl.show({
          // el: this.$refs.alerts,
          title: "解读",
          confirmMsg: this.$t("tag.guanbi"),
          text: txt
        });
      }
    },
  },
  beforeDestroy() {
    if (!this.chart) {
      return;
    }
    this.chart.dispose();
    this.chart = null;
  },
  computed: {
    options() {
      return {
        series: {
          name: this.$t("components.xuetang"),
          type: "line",
          sampling: "average",
          color: "#FB79B6",
          data: this.bsugarValue
        },
        color: "#3696ea",
        grid: {
          containLabel: true,
          top: 20,
          bottom: 10,
          left: 0,
          right: 0
        },
        xAxis: {
          type: "category",
          axisLine: {
            lineStyle: {
              type: "solid",
              color: "#54657e",
              width: 1
            }
          },
          axisTick: {
            show: true
          },
          data: this.chart_x_time
        },
        yAxis: [
          {
            type: "value",
            axisLabel: {
              show: true,
              formatter: function (value, index) {
                return value + "mmol/L";
              }
            },
            axisTick: {
              show: false
            },
            axisLine: {
              lineStyle: {
                color: "#54657e"
              }
            },
            splitLine: {
              show: false
            }
          }
        ],
        dataZoom: [
          {
            type: "inside",
            start: 0,
            end: 100
          }
        ],
        tooltip: {
          trigger: "axis",
          formatter: "{a}: {c} mmol/L"
          // formatter: function (params) {
          //   if (params[0].value != null) {
          //     return params[0].axisValue + '<br/>' + '血糖:' + params[0].value + 'mmol/L'
          //   } else {
          //     return params[0].axisValue + '<br/>' + '未检测到血糖数据'
          //   }
          // }
        }
      };
    }
  },
  watch: {
    sendTime: function (newval, oldval) {
      this.getEchartsDataInfo();
    }
  }
};
</script>
<style lang="stylus">
@import '~styles/variable.styl';
@import '~styles/global.styl';
</style>



// WEBPACK FOOTER //
// src/pages/year-data/components/yearSugar.vue